import React from 'react'
import Slider from "react-slick"




class MiddleBanner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    onNext() {
        this.slider.slickNext();
    }
    onPrevious() {
        this.slider.slickPrev();
    }

    render() {
        const banner = this.props.headerRightBanner
        if (banner.length === 0) return ''
        let sliderOptions  = {
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: 0,
            arrows: false,
            className: 'HTMBSlider',
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
        }
        return (
            <div className="HTMBanner HTMObj rltvObj">
                <Slider ref={r => (this.slider = r)} {...sliderOptions}>
                    {banner.map((v, i) => {
                        return (
                            <div key={i}>
                                <a href={v.url} rel="noopener noreferrer" target="_blank">
                                    <img src={v.img} alt={v.title}/>
                                </a>
                            </div>
                        )
                    })}
                </Slider>
                <button type="button" className="prevBtn" onClick={()=>this.onPrevious()}><span className="ir">이전</span></button>
                <button type="button" className="nextBtn" onClick={()=>this.onNext()}><span className="ir">다음</span></button>
            </div>
        )
    }
}

export default MiddleBanner;



// WEBPACK FOOTER //
// ./src/header/component/middleBanner.js